import { render, staticRenderFns } from "./detailsComponent.vue?vue&type=template&id=fd72744e"
import script from "./detailsComponent.vue?vue&type=script&lang=js"
export * from "./detailsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports